/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { Theme } from "@mui/material";

const documentStyle = {
  paper: {
    padding: "0.25rem 1rem 1rem",
  },
  inlineHintBox: (theme: Theme) => ({
    margin: "0 auto 40px auto",
    maxWidth: "700px",
    textAlign: "left",
    "& h6": {
      color: theme.palette.text.primary,
      marginBottom: "20px",
    },
  }),
  buttonContainer: {
    maxWidth: "350px",
    margin: "0 auto 40px auto",
  },
  divider: {
    borderBottom: "2px solid #ccc",
    margin: "1.5rem 0",
  },
  uploadButton: {
    marginTop: "1rem",
  },
  headline: (theme: Theme) => ({
    textAlign: "left",
    color: theme.palette.text.primary,
    marginBottom: "40px",
  }),
};

export default documentStyle;
